import React, { useEffect } from "react";
import { observer } from "mobx-react-lite";
import EventPageLayout from "./components/EventPageLayout";
import EventHeader from "./components/EventHeader";
import GuestListCard from "./components/GuestListCard";
import SetupsCard from "./components/SetupsCard";
import EventStore from "./store/eventStore";
import CommunityNavigationStore, {
  CommunityView,
} from "../navigation/communityNavigationStore";
import LoadingOverlay from "../shared/components/LoadingOverlay";

const EventPageComponent = observer(() => {
  useEffect(() => {
    if (EventStore.sitchEventData?.guid) {
      EventStore.loadEventData(EventStore.sitchEventData.guid);
    }
  }, []);

  const hasGuests = (EventStore.attendeesSummary?.num_attendees_total || 0) > 0;
  const hasGeneratedSetups = EventStore.sitchEventData?.rounds?.some(
    (round: { num_matches_created?: number | null }) =>
      (round.num_matches_created || 0) > 0,
  );

  const handleViewFullGuestList = async () => {
    CommunityNavigationStore.navigateTo(CommunityView.GUEST_LIST);
  };

  const handleViewGuestAdd = async () => {
    CommunityNavigationStore.navigateTo(CommunityView.GUEST_ADD);
  };

  const handleManageManualSetups = () => {
    CommunityNavigationStore.navigateTo(CommunityView.MANUAL_MATCH);
  };

  const handleViewSetups = () => {
    CommunityNavigationStore.navigateTo(CommunityView.SETUPS);
  };

  const handleCreateManualSetups = () => {
    CommunityNavigationStore.navigateTo(CommunityView.MANUAL_MATCH);
  };

  const handleGenerateSetups = async () => {
    await EventStore.generateSetups();
    CommunityNavigationStore.navigateTo(CommunityView.SETUPS);
  };

  return (
    <>
      <LoadingOverlay isVisible={EventStore.isLoading} />
      <EventPageLayout>
        <EventHeader
          eventName={EventStore.sitchEventData?.name || "Sample Event"}
          eventDate={
            EventStore.sitchEventData?.time_event_starts ||
            new Date().toISOString()
          }
          eventId={EventStore.sitchEventData?.guid || ""}
        />

        <GuestListCard
          guestStats={EventStore.attendeesSummary}
          hasGeneratedSetups={hasGeneratedSetups || false}
          onSendInviteLink={EventStore.sendInviteLink}
          onViewFullGuestList={handleViewFullGuestList}
          onViewGuestAdd={handleViewGuestAdd}
          eventId={EventStore.sitchEventData?.guid}
        />

        <SetupsCard
          eventDateTime={
            new Date(EventStore.sitchEventData?.time_event_starts || Date.now())
          }
          hasGuests={hasGuests}
          hasGeneratedSetups={hasGeneratedSetups || false}
          onCreateManualSetups={handleCreateManualSetups}
          onGenerateSetups={handleGenerateSetups}
          onSeeSetups={handleViewSetups}
          onManageManualSetups={handleManageManualSetups}
        />
      </EventPageLayout>
    </>
  );
});

export default EventPageComponent;
